import React from 'react';

// A semantic, clickable cross-link between admin entities.
// Usage: <RelLink tab="certs" filters={{ certNumber: '98220183' }} goTo={goTo}>98220183</RelLink>
const RelLink = ({ tab, filters = {}, goTo, children, title, className = '' }) => {
    if (!children && children !== 0) return <span>—</span>;
    return (
        <button
            type="button"
            className={`rel-link ${className}`.trim()}
            title={title || `Jump to ${tab}`}
            onClick={(e) => {
                e.stopPropagation();
                goTo({ tab, ...filters });
            }}
        >
            {children}
        </button>
    );
};

export default RelLink;
